import React, { useState } from "react";
import OTLayout from "./OTLayout";
import { CHECKLIST_SECTIONS } from "./mockData";
import {
  OtPage,
  SectionCard,
  Box,
  Grid,
  Typography,
  Stack,
  Chip,
  Button,
  eyebrowSx,
  titleSx,
  subtitleSx,
} from "./ui";
import { C } from "./constants";
import SvgIcon from "../ipd-billing/SvgIcon";

export default function OTChecklists() {
  const [done, setDone] = useState({});
  const toggle = (key) => setDone((prev) => ({ ...prev, [key]: !prev[key] }));

  return (
    <OTLayout activeNav="checklists">
      <OtPage>
        <Typography sx={eyebrowSx}>WHO Surgical Safety</Typography>
        <Typography component="h1" sx={titleSx}>OT checklists</Typography>
        <Typography sx={{ ...subtitleSx, mb: 3 }}>Tap each item as it is verified by the team.</Typography>

        <Grid container spacing={2}>
          {CHECKLIST_SECTIONS.map((sec) => {
            const completed = sec.items.filter((_, i) => done[`${sec.title}-${i}`]).length;
            return (
              <Grid item xs={12} md={4} key={sec.title}>
                <SectionCard sx={{ p: 2.5 }}>
                  <Stack direction="row" justifyContent="space-between" alignItems="flex-start">
                    <Box>
                      <Typography component="h2" sx={{ fontSize: 16, fontWeight: 700 }}>{sec.title}</Typography>
                      <Typography sx={{ mt: 0.5, fontSize: 12, color: C.textSub }}>{sec.subtitle}</Typography>
                    </Box>
                    <Chip
                      label={`${completed}/${sec.items.length}`}
                      size="small"
                      sx={{
                        height: "auto",
                        borderRadius: 999,
                        fontSize: 11,
                        fontWeight: 700,
                        bgcolor: "#E9F5FE",
                        color: C.primary,
                        "& .MuiChip-label": { px: 1.25, py: 0.25 },
                      }}
                    />
                  </Stack>
                  <Stack component="ul" spacing={1} sx={{ mt: 2, p: 0, m: 0, listStyle: "none" }}>
                    {sec.items.map((item, i) => {
                      const key = `${sec.title}-${i}`;
                      const isDone = !!done[key];
                      return (
                        <Box component="li" key={key}>
                          <Button
                            onClick={() => toggle(key)}
                            fullWidth
                            sx={{
                              display: "flex",
                              justifyContent: "flex-start",
                              alignItems: "flex-start",
                              gap: 1.25,
                              p: "10px 12px",
                              borderRadius: "8px",
                              border: `1px solid ${isDone ? "#badbcc" : C.border}`,
                              bgcolor: isDone ? "#d1f2db" : "#fff",
                              color: C.text,
                              fontSize: 13,
                              fontWeight: 400,
                              textTransform: "none",
                              textAlign: "left",
                              "&:hover": { bgcolor: isDone ? "#d1f2db" : "#fff", borderColor: isDone ? "#badbcc" : C.primary },
                            }}
                          >
                            <SvgIcon name={isDone ? "check" : "plus"} size={16} color={isDone ? C.success : C.textSub} />
                            <Typography
                              sx={{
                                textDecoration: isDone ? "line-through" : "none",
                                opacity: isDone ? 0.75 : 1,
                                fontSize: 13,
                                color: "inherit",
                              }}
                            >
                              {item}
                            </Typography>
                          </Button>
                        </Box>
                      );
                    })}
                  </Stack>
                </SectionCard>
              </Grid>
            );
          })}
        </Grid>
      </OtPage>
    </OTLayout>
  );
}
